import { useMemo } from "react";

import { useModelUsageSummaryQuery } from "@/apollo/types";
import { PercentageCircle } from "@/components/elements/PercentageCircle";
import { NavButton } from "@/components/elements/Sidebar";
import {
  INTERCOM_ONBOARDING_CHECKLIST,
  useIntercom,
} from "@/features/intercom";
import { useEltSyncs } from "@/hooks/useSync";
import { useCurrentAccount } from "@/providers/account";
import dayjs from "@/utils/date";
import { RocketIcon } from "lucide-react";
const OnboardingChecklistButton = () => {
  const account = useCurrentAccount();
  const accountCreated = dayjs(account.createdAt);
  const { startChecklist } = useIntercom();

  const { percent, loading, isComplete } = useChecklistStatus();

  //Only show if account was created in the last 21 days:
  if (accountCreated.isBefore(dayjs().subtract(21, "days"))) return null;

  if (loading) return null;

  if (isComplete) return null;

  return (
    <NavButton
      icon={
        <div className="relative flex items-center justify-center rounded-full">
          <PercentageCircle
            percentage={percent / 100}
            className="absolute top-0 left-0 mt-[-25%] ml-[-25%] h-[150%] w-[150%]"
          />
          <RocketIcon className="size-4" />
        </div>
      }
      onClick={() => {
        startChecklist(INTERCOM_ONBOARDING_CHECKLIST);
      }}
    >
      Onboarding guide
    </NavButton>
  );
};

export default OnboardingChecklistButton;

const useChecklistStatus = () => {
  const { eltSyncs, loading: loadingElt } = useEltSyncs();

  const { data: modelUsageSummaryData, loading: loadingModelsSummary } =
    useModelUsageSummaryQuery();

  const { publishedModels = 0, draftModels = 0 } =
    modelUsageSummaryData?.modelUsageSummary || {};
  const totalModels = publishedModels + draftModels;

  const loading = loadingElt || loadingModelsSummary;

  return useMemo(() => {
    if (eltSyncs.length === 0) {
      return { step: 1, percent: 0, loading, isComplete: false };
    }
    if (totalModels === 0) {
      return { step: 2, percent: 50, loading, isComplete: false };
    }
    return { step: 3, percent: 100, loading, isComplete: true };
  }, [eltSyncs.length, loading, totalModels]);
};
